module.exports = __webpack_public_path__ + "static/media/3.09ce012d.png";